<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="用户ID" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入用户ID" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="动态类型" prop="type" >-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="动态内容" prop="content" >
        <a-input  type="textarea" v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="linkAddress" v-if="form.imageVideo == 1 && form.linkAddress !=null">
        <img v-viewer   style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
         v-for="item in form.linkAddress.split(',')"    :src="item" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="视频" v-if="form.imageVideo == 2 && form.linkAddress !=null" prop="linkAddress" >
        <video   style="width: 180px;height: 120px"
               class="avatar video-avatar"
               controls="controls"  :src="form.linkAddress"/>
      </a-form-model-item>
      <a-form-model-item label="分类" prop="category" v-if="form.category">
        <a-input readOnly v-model="form.categoryStr"/>
      </a-form-model-item>

<!--      <a-form-model-item label="话题" prop="talk" v-if="form.talk">-->
<!--        <a-input readOnly v-model="form.talkStr"/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="心情ID｛emotion_pack.id｝" prop="emoticonId" >-->
<!--        <a-input v-model="form.emoticonId" placeholder="请输入心情ID｛emotion_pack.id｝" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="所在城市位置" prop="location" v-if="form.location">
        <a-input readOnly v-model="form.location" placeholder="请输入所在城市位置" />
      </a-form-model-item>
<!--      <a-form-model-item label="经度" prop="longitude" >-->
<!--        <a-input v-model="form.longitude" placeholder="请输入经度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="纬度" prop="latitude" >-->
<!--        <a-input v-model="form.latitude" placeholder="请输入纬度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="可见类型" prop="visibleType" >-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="不可见人ID" prop="invisibleIds" >-->
<!--        <a-input v-model="form.invisibleIds" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="点赞数" prop="likeNum" >-->
<!--        <a-input v-model="form.likeNum" placeholder="请输入点赞数" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="是否存为草稿" prop="isDraft" >-->
<!--        <a-input v-model="form.isDraft" placeholder="请输入是否存为草稿" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
         <a-button type="primary" :loading="submitLoading" @click="submitForm">
           保存
         </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInfo, addInfo, updateInfo } from '@/api/dynamics/info'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,
        imageVideo:null,
        linkAddress: null,

        category: null,
        categoryStr:null,
        talk: null,
        talkStr:null,
        emoticonId: null,
        emotionIcon:null,
        emotionStr:null,
        location: null,

        longitude: null,

        latitude: null,

        visibleType: null,

        invisibleIds: null,

        likeNum: null,

        isDraft: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '动态类型不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '动态内容不能为空', trigger: 'blur' }
        ],
        linkAddress: [
          { required: true, message: '图片，视频地址不能为空', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '分类不能为空', trigger: 'blur' }
        ],
        talk: [
          { required: true, message: '话题不能为空', trigger: 'blur' }
        ],
        emoticonId: [
          { required: true, message: '心情ID｛emotion_pack.id｝不能为空', trigger: 'blur' }
        ],
        location: [
          { required: true, message: '所在城市位置不能为空', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '经度不能为空', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '纬度不能为空', trigger: 'blur' }
        ],
        visibleType: [
          { required: true, message: '可见类型不能为空', trigger: 'change' }
        ],
        likeNum: [
          { required: true, message: '点赞数不能为空', trigger: 'blur' }
        ],
        isDraft: [
          { required: true, message: '是否存为草稿不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    // 可用的分类选项（排除当前节点及其子节点）
    filteredCategoryOptions () {
      if (this.formType === 1 || !this.form.id) {
        // 新增时，显示所有分类
        return this.categoryOptions
      }
      // 修改时，排除当前节点及其子节点
      return this.excludeNodeAndChildren(this.categoryOptions, this.form.id)
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        linkAddress: null,
        imageVideo:null,
        category: null,
        categoryList:[],
        talk: null,
        talkList:[],
        emoticonId: null,
        emotionIcon:null,
        emotionStr:null,
        location: null,
        longitude: null,
        latitude: null,
        visibleType: null,
        invisibleIds: null,
        likeNum: null,
        isDraft: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getInfo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },

    handleInfo (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getInfo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateInfo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addInfo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
